import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router/dom";
import { queryClient } from "./app/queryClient";
import { router } from "./app/router";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/foundation.css";
import "./features/generator/generator-pair.css";
import "./features/preparation/staff-editor-modal.css";
import "./features/preparation/team-readable.css";
import "./features/manual/manual-board-readability.css";
import "./styles/readability.css";
import "./styles/ui-refresh.css";
import "./styles/ui-refresh-context.css";
import "./styles/ui-refresh-modules.css";
import "./styles/ui-refresh-safety.css";
import "./styles/premium-foundation.css";
import "./styles/radical-future-theme.css";
import "./styles/aurora-obsidian-system.css";
import "./styles/aurora-obsidian-priority-pages.css";
import "./styles/aurora-obsidian-catalog.css";
import "./styles/aurora-obsidian-operations.css";
import "./styles/aurora-obsidian-quality-fixes.css";
import "./styles/responsive-quality-gate.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
